var map = {
	"./2arrow.svg": "0fe0",
	"./Unio.svg": "89de",
	"./Union.svg": "cf71",
	"./UserIcons.svg": "234c",
	"./acceptIcon.svg": "41f5",
	"./add_box.svg": "5a57",
	"./add_icon.svg": "82c9",
	"./alertCircle.svg": "caa8",
	"./archiv_icon.svg": "7e67",
	"./arrow-choice.svg": "304a",
	"./arrow-pagination-all.svg": "5c82",
	"./arrow-pagination.svg": "ea60",
	"./arrow-select.svg": "5c5f",
	"./arrow.svg": "d512",
	"./arrowCurrentColor.svg": "53a0",
	"./arrowIndicator.svg": "33d5",
	"./arrow_back.svg": "96e8",
	"./arrow_down.svg": "f545",
	"./arrow_down2.svg": "3560",
	"./arrow_tree_table_down.svg": "8beb",
	"./arrow_up.svg": "37d9",
	"./attach_file.svg": "4ece",
	"./attentionSigh.svg": "b47c",
	"./auto.svg": "8c38",
	"./avatar.png": "2adc",
	"./award.svg": "507c",
	"./banSigh.svg": "cf77",
	"./bar-chart.svg": "5a1a",
	"./boat.svg": "407d",
	"./bullhorn.svg": "bbfe",
	"./card3.svg": "6404",
	"./case.svg": "91e7",
	"./chart-line.svg": "c259",
	"./chartIcon.svg": "7254",
	"./checkbox.svg": "1dd6",
	"./checked.svg": "abe5",
	"./chemistry.svg": "548c",
	"./chevronDownSort.svg": "6413",
	"./cir-close.svg": "c970",
	"./cir-done.svg": "b0d7",
	"./cir-inWork.svg": "240a",
	"./cir-late.svg": "7bfa",
	"./clear.svg": "a7f8",
	"./clear_cross.svg": "c76a",
	"./clear_cross_transparent.svg": "eb6a",
	"./closeClean.svg": "7f4e",
	"./closeCross.svg": "df62",
	"./cog.svg": "0327",
	"./copy.svg": "4746",
	"./copy2.svg": "6d61",
	"./copy3.svg": "e235",
	"./cow.svg": "3c52",
	"./crossInCircle.svg": "d3d9",
	"./database.svg": "9a13",
	"./dateRange.svg": "4a61",
	"./daw.svg": "915e",
	"./delete-not-fill.svg": "4aa3",
	"./delete.svg": "0ab2",
	"./doc-redesigned.svg": "bf83",
	"./docsIcon.svg": "0504",
	"./document-redesign.svg": "4a62",
	"./donut-chart.svg": "4233",
	"./dots.svg": "7d22",
	"./dotsicon.svg": "f1e8",
	"./double-chevron.svg": "8fcc",
	"./download-array.svg": "9ff8",
	"./download.svg": "5ed4",
	"./downloadBlue.svg": "1b40",
	"./downloadWithArrow.svg": "d587",
	"./download_transparent.svg": "e8a7",
	"./drag-and-drop.svg": "b59b",
	"./edit.svg": "a811",
	"./ellips-gradient.svg": "ae9b",
	"./ellipses.svg": "8a21",
	"./empty_pen.svg": "0f7d",
	"./error.svg": "3a60",
	"./errorIcon.svg": "4599",
	"./esia.svg": "ff29",
	"./event-note.svg": "1764",
	"./external-link.svg": "a25f",
	"./eye.svg": "a245",
	"./eyeCrossedOut.svg": "5edb",
	"./facebook.svg": "a79d",
	"./favorite_icon.svg": "7243",
	"./file.svg": "10a5",
	"./fileDoc.svg": "a840",
	"./fileText.svg": "fc6c",
	"./fileTimes.svg": "e229",
	"./fileUpload.svg": "908a",
	"./filter.svg": "b930",
	"./flag.svg": "dadc",
	"./flagFilled.svg": "c518",
	"./folder.svg": "e855",
	"./followStar.svg": "f385",
	"./frame88.svg": "6319",
	"./goodSigh.svg": "948a",
	"./grayGoodSigh.svg": "fba1",
	"./groupMeet.svg": "7991",
	"./ic_search.svg": "b4fa",
	"./id-badge.svg": "28ee",
	"./import.svg": "9428",
	"./indeterminate.svg": "8834",
	"./info.svg": "6dcc",
	"./infoSign.svg": "9c42",
	"./logo.svg": "a8bf",
	"./logout.svg": "6839",
	"./map.svg": "bd33",
	"./meet.svg": "9ac8",
	"./mess-bg.svg": "2750",
	"./mess_icon1.svg": "9489",
	"./mess_user.svg": "6ec2",
	"./message_icon-fill.svg": "43b5",
	"./message_icon.svg": "f53b",
	"./messicon.svg": "f133",
	"./minus-mini.svg": "7759",
	"./minus.svg": "2595",
	"./mode.svg": "5ab7",
	"./moneyIcon.svg": "bd10",
	"./news.svg": "8a5d",
	"./notif.svg": "df8c",
	"./notify_icon.svg": "4ccf",
	"./paper-download.svg": "789b",
	"./paper-plus.svg": "5477",
	"./paper.svg": "ec0d",
	"./pdf/logo-back.svg": "2126",
	"./pdf/logo.svg": "e8a5",
	"./pie-chart.svg": "f712",
	"./pie-chart2.svg": "f030",
	"./plain.svg": "9b23",
	"./plus-mini.svg": "84e7",
	"./plus.svg": "0205",
	"./plusIcon.svg": "b7a3",
	"./plus_btn.svg": "a79a",
	"./plus_transparent.svg": "ff39",
	"./plus_white.svg": "3f47",
	"./project-diagram.svg": "30b3",
	"./question_answer.svg": "ce3c",
	"./radio.svg": "5e3e",
	"./radioActive.svg": "a781",
	"./refreshSigh.svg": "dcc7",
	"./remove.svg": "4e4d",
	"./reply.svg": "30d9",
	"./reply_all.svg": "4ae0",
	"./restore.svg": "9dbd",
	"./search.svg": "2845",
	"./search2.svg": "e713",
	"./searchPlus.svg": "2476",
	"./search_currentCol.svg": "9693",
	"./send.svg": "05cd",
	"./setting.svg": "be5d",
	"./settings.svg": "605e",
	"./social-dz.svg": "053a",
	"./social-ok.svg": "9649",
	"./social-tg.svg": "3901",
	"./social-vk.svg": "512e",
	"./social-yt.svg": "a523",
	"./sort_arrow_up.svg": "d24a",
	"./stages/alert-triangle.svg": "071b",
	"./stages/bag.svg": "f5c2",
	"./stages/barrier.svg": "ba50",
	"./stages/barrier2.svg": "9a02",
	"./stages/boxBlack.svg": "04e3",
	"./stages/card.svg": "8abd",
	"./stages/cart.svg": "19a6",
	"./stages/document.svg": "adfd",
	"./stages/export.svg": "7d81",
	"./stages/factory.svg": "700e",
	"./stages/furgon.svg": "a9f4",
	"./stages/globe.svg": "a6bb",
	"./stages/house.svg": "bcb9",
	"./stages/shopping-bag.svg": "805e",
	"./stages/user-check.svg": "abed",
	"./star2.svg": "2879",
	"./starFilled.svg": "ff75",
	"./starNotFilled.svg": "b096",
	"./status.svg": "de82",
	"./support_icon.svg": "d2df",
	"./table.svg": "ab2f",
	"./tableOne.svg": "d33a",
	"./telegramm.svg": "d87a",
	"./threeStripes.svg": "f2d1",
	"./thumbtack-solid.svg": "c611",
	"./thumbtack.svg": "0692",
	"./time-redesign.svg": "5579",
	"./time.svg": "f7e8",
	"./timesCircle.svg": "6262",
	"./tooltip-info.svg": "35cb",
	"./tooltip.svg": "d7d3",
	"./train.svg": "cb45",
	"./triple-dots.svg": "950d",
	"./tune.svg": "75a6",
	"./twitter.svg": "7f26",
	"./upload_file.svg": "0b00",
	"./user.svg": "79c9",
	"./userIcon.svg": "a0db",
	"./video_group.svg": "b34a",
	"./vk.svg": "8c59",
	"./youtube.svg": "2931"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af8c";